<template>
  <div class="checkbox-wrapper">
    <label
      :class="{
        'is-checked': checked,
        'is-disabled': disabled,
        'has-error': error,
        'full-width': wide,
      }"
      class="checkbox"
    >
      <input
        :id="id"
        :key="id"
        ref="input"
        type="checkbox"
        :checked="checked"
        :name="id"
        :disabled="disabled"
        @change="$emit('change', $event.target.checked)"
      >
      <span
        v-add-zuko-tag
        class="checkbox__container d-flex align-center"
        :data-test="dataTest"
      >
        <v-icon :color="checked ? 'white' : 'primary'">
          {{ checked ? iconActive : iconBase }}
        </v-icon>
        <span
          class="checkbox__title"
        >
          <slot />
        </span>
      </span>
    </label>
  </div>
</template>

<script>
import { mdiCheckboxBlankOutline, mdiCheckboxMarked } from '@mdi/js';

export default {
  name: 'checkbox-button',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    dataTest: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    iconBase: {
      type: String,
      default: mdiCheckboxBlankOutline,
    },
    iconActive: {
      type: String,
      default: mdiCheckboxMarked,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    id () {
      return this.name.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  & + & {
    margin-top: 10px;
  }
}

.checkbox {
  width: 100%;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  user-select: none;
  position: relative;
  display: inline-block;
  vertical-align: middle;

  input {
    width: 0.1px;
    opacity: 0;
    overflow: hidden;
    height: 0.1px;
    position: absolute;
    z-index: -1;
  }

  &__container {
    border: 1px solid var(--v-primary-base, $clr-primary);
    color: var(--v-text-base, $clr-help-text);
    padding: 15px;
    border-radius: 6px;
    transition-property: color, background-color;
    transition-duration: 0.15s;
    transition-timing-function: ease-in-out;
  }

  input:focus + &__container {
    box-shadow: inset 0 0 0 1px var(--v-primary-base, $clr-primary);
  }

  input:checked + &__container,
  &.is-checked &__container {
    color: $clr-white;
    background-color: var(--v-primary-base, $clr-primary);
  }

  &:not(.is-checked):hover &__container,
  &:hover input:not(:checked) + &__container {
    background-color: rgba(var(--v-primary-rgb, $clr-primary-rgb), 0.15);
  }

  &.has-error &__container {
    border: 1px solid var(--v-error-base, $clr-error);
  }

  &.has-error:not(.is-checked):hover &__container,
  &.has-error:hover input:not(:checked) + &__container {
    background-color: rgba(var(--v-error-rgb, $clr-error-rgb), 0.15);
  }

  &.has-error input:checked + &__container,
  &.has-error.is-checked &__container {
    background-color: var(--v-error-base, $clr-error);
  }

  &.has-error &__icon {
    color: var(--v-error-base, $clr-error);
  }

  &__title {
    flex-grow: 1;
    margin-left: 12px;
  }

  input:disabled + &__container,
  &.is-disabled &__container {
    cursor: not-allowed;
    opacity: 0.4;
  }
}
</style>
